/* hs-eslint ignored failing-rules */
/* eslint-disable no-prototype-builtins */

import PropTypes from 'prop-types';
import { Component } from 'react';
import { isCrmPropertiesField } from '../../utils/typeUtils';
import { getSchemaType, retrieveSchema, ADDITIONAL_PROPERTY_FLAG, getIsPropertyRequired } from '../../utils/schemaUtils';
import { getAvailableKey } from '../../utils/additionalPropertyUtils';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
import Markdown from '../../../Doc/components/Markdown';
import SchemaField from './SchemaField';
import DescriptorBlock from './shared/DescriptorBlock';
import AddButton from './shared/AddButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Description = ({
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  children,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  idPrefix,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  onKeyChange,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  required,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  schema,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  schemaGroup,
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  title
}) => {
  const isAdditionalProperty = schema.hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);
  return /*#__PURE__*/_jsxs("div", {
    className: "params-row",
    children: [/*#__PURE__*/_jsxs("div", {
      className: "params-pair",
      children: [/*#__PURE__*/_jsx(DescriptorBlock
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        description: schema.description,
        id: idPrefix,
        label: title,
        onKeyChange: onKeyChange,
        required: required,
        schema: schema,
        schemaGroup: schemaGroup,
        schemaTypeI18nKey: "types.object",
        isAdditionalProperty: isAdditionalProperty
      }), /*#__PURE__*/_jsx("div", {
        className: "params-content",
        children: schema.description && /*#__PURE__*/_jsx(Markdown, {
          inline: true,
          breakWord: false,
          children: schema.description
        })
      })]
    }), children]
  }, `${idPrefix}-description`);
};
export default class ObjectField extends Component {
  constructor(...args) {
    super(...args);
    this.canExpand = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        formData,
        schema
      } = this.props;
      if (!schema.additionalProperties) {
        return false;
      }
      if (schema.maxProperties !== undefined) {
        return Object.keys(formData).length < schema.maxProperties;
      }
      return true;
    };
    this.createPropertyAddHandler = schema => () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        formData,
        registry
      } = this.props;
      let type = schema.additionalProperties.type;
      const newFormData = Object.assign({}, formData);
      if (type === undefined && schema.additionalProperties.hasOwnProperty('$ref')) {
        const refSchema = retrieveSchema(schema.additionalProperties, registry.definitions, formData);
        type = refSchema.type;
      }
      newFormData[getAvailableKey(I18n.text('developer-docs-shared-components.params.body.additionalProperties.defaultKey'), newFormData)] = null;

      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.onChange(newFormData);
    };
    this.createKeyChangeHandler = oldValue => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return value => {
        if (oldValue === value) {
          return;
        }
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        const {
          formData
        } = this.props;
        value = getAvailableKey(value, formData);
        const newFormData = Object.assign({}, formData);
        const newKeys = {
          [oldValue]: value
        };
        const keyValues = Object.keys(newFormData).map(key => {
          /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
          const newKey = newKeys[key] || key;
          return {
            [newKey]: newFormData[key]
          };
        });
        const renamedObj = Object.assign({}, ...keyValues);
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.onChange(renamedObj, this.props.errorSchema);
      };
    };
    this.createPropertyChangeHandler = (name, addedByAdditionalProperties = false) => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      return (value, errorSchema) => {
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        const {
          formData
        } = this.props;
        if (!value && addedByAdditionalProperties) {
          // Don't set value = undefined for fields added by
          // additionalProperties. Doing so removes them from the
          // formData, which causes them to completely disappear
          // (including the input field for the property name). Unlike
          // fields which are "mandated" by the schema, these fields can
          // be set to undefined by clicking a "delete field" button, so
          // set empty values to the empty string.
          value = '';
        } else if (value === null) {
          value = undefined;
        } else if (value.properties && formData.properties) {
          // Sometimes Object properties that already have a properties param will
          // be updated. In order to prevent this param from being duplicated,
          // we need to remove one of the properties params.
          value = value.properties;
        }
        const newFormData = Object.assign({}, formData, {
          [name]: value
        });
        /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.onChange(newFormData, errorSchema && /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
        this.props.errorSchema && Object.assign({}, this.props.errorSchema, {
          [name]: errorSchema
        }));
      };
    };
    this.renderAddAdditionalPropertyButton = () => {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      const {
        disabled,
        readOnly,
        schema
      } = this.props;
      return /*#__PURE__*/_jsx("div", {
        className: "params-add-additional-property-button-row",
        children: /*#__PURE__*/_jsx(AddButton, {
          onClick: this.createPropertyAddHandler(schema),
          disabled: disabled || readOnly,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "developer-docs-shared-components.params.body.additionalProperties.buttonText"
          })
        })
      });
    };
  }
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
  render() {
    const {
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errorSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      formData,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idPrefix,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      idSchema,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      name: schemaName,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      readOnly,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      registry,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      required,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      schemaGroup,
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      onKeyChange
    } = this.props;
    const {
      definitions
    } = registry;
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const schema = retrieveSchema(this.props.schema, definitions, formData);
    const title = schema.title || schemaName;
    const properties = Object.keys(schema.properties || {}).map(name => {
      const addedByAdditionalProperties = schema.properties[name].hasOwnProperty(ADDITIONAL_PROPERTY_FLAG);

      /*
        Generally, CRM `properties` fields are the only body param
        for a request. When they aren't, we need to set up their
        form data correctly.
      */
      const schemaType = getSchemaType(schema.properties[name]);
      const isPropertiesField = isCrmPropertiesField( /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      this.props.schema, schemaType, idSchema, name);
      const newFormData = isPropertiesField ? {
        properties: (formData || {})[name]
      } : (formData || {})[name];
      return /*#__PURE__*/_jsx(SchemaField
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        errorSchema: errorSchema[name],
        formData: newFormData,
        idPrefix: idPrefix,
        idSchema: idSchema[name],
        name: name,
        onChange: this.createPropertyChangeHandler(name, addedByAdditionalProperties),
        onKeyChange: this.createKeyChangeHandler(name),
        readOnly: readOnly,
        registry: registry,
        required: getIsPropertyRequired(schema, name),
        schema: schema.properties[name],
        schemaGroup: schemaGroup
      }, `${name}`);
    });
    if (title || schema.description) {
      return /*#__PURE__*/_jsxs(Description
      /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */, {
        canExpand: this.canExpand(),
        idPrefix: idPrefix || idSchema.$id,
        required: required,
        schema: schema,
        schemaGroup: schemaGroup,
        title: title,
        onKeyChange: onKeyChange,
        children: [properties, this.canExpand() && this.renderAddAdditionalPropertyButton()]
      });
    }
    return properties;
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ObjectField.propTypes = {
  disabled: PropTypes.bool,
  errorSchema: PropTypes.object,
  formData: PropTypes.any,
  idPrefix: PropTypes.string,
  idSchema: PropTypes.object,
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onKeyChange: PropTypes.func,
  readOnly: PropTypes.bool,
  registry: PropTypes.object.isRequired,
  required: PropTypes.bool,
  schema: PropTypes.object.isRequired,
  schemaGroup: PropTypes.string
};